import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { importExcelData } from '../../store/slices/leadImportSlice';
import { useNavigate } from 'react-router-dom';
import { useCurrencySymbol } from '../../utils/currencyUtils';
import { fetchLeads } from '../../store/slices/leadsSlice';
import {
    isWonLeadStatusValue,
    withDirectWonCommentMarker,
} from '../../utils/isDirectWonLead';

const Multipleleadexport = ({
    canShowDownloadTemplate = true,
    canShowImportLeads = true,
    isDownloadTemplateViewOnly = false,
    isImportLeadsViewOnly = false,
    leftActions = null,
}) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currency = useCurrencySymbol();

    const [excelData, setExcelData] = useState(null);
    const [extractedData, setExtractedData] = useState([]);
    console.log("ProceextractedData", extractedData);
    const { leads } = useSelector((state) => state.leads);

    useEffect(() => {
        dispatch(fetchLeads())
    }, [dispatch]);

    const downloadExcel = () => {
        if (isDownloadTemplateViewOnly) return;
        const headings = [
            {
                LeadDate: "",
                ClientName: "",
                Source: "",
                Reference: "",
                Group: "",
                TypeOfService: "",
                ProjectName: "",
                [`QuotedValue ${currency}`]: "",
                ContactPerson: "",
                EmailID: "",
                MobileNumber: "",
                Status: "",
                Probability: "",
                NextFollowupDate: "",
                LeadType: "",
                Comments: "",

            },
        ];

        const ws = XLSX.utils.json_to_sheet(headings, { skipHeader: false });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sample File");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        saveAs(excelFile, "Sample.xlsx");
    };

    const extractDataFromExcel = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });

                    // Get the first worksheet name
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];

                    // Convert worksheet to JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                        header: 1, // Get as array of arrays
                        defval: "", // Default value for empty cells
                        raw: false // Get formatted strings
                    });

                    resolve(jsonData);
                } catch (error) {
                    reject(error);
                }
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsArrayBuffer(file);
        });
    };

    const handleFileChange = async (e) => {
        if (isImportLeadsViewOnly) return;
        const file = e.target.files[0];
        if (file) {
            const validTypes = [
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ];

            if (!validTypes.includes(file.type)) {
                enqueueSnackbar("Please upload a valid Excel file (.xls or .xlsx)", {
                    variant: "error",
                });
                e.target.value = "";
                return;
            }

            try {
                setExcelData(file);

                // Extract data from the Excel file
                const extractedData = await extractDataFromExcel(file);
                console.log("Extracted Excel Data:", extractedData);

                // Process the extracted data
                processExtractedData(extractedData);

                // enqueueSnackbar("Excel file processed successfully!", {
                //     variant: "success",
                // });

            } catch (error) {
                console.error("Error reading Excel file:", error);
                enqueueSnackbar("Error reading Excel file. Please check the format.", {
                    variant: "error",
                });
                e.target.value = "";
                setExcelData(null);
            }
        }
    };

    const processExtractedData = (data) => {
        if (!data || data.length === 0) {
            enqueueSnackbar("No data found in the Excel file", {
                variant: "warning",
            });
            return;
        }

        // Remove header row if needed (first row)
        const headers = data[0];
        console.log("Headers:", headers);


        // Convert to array of objects if you have headers
        const objectsArray = data.slice(1).map(row => {
            const obj = {};
            headers.forEach((header, index) => {
                obj[header] = row[index] || '';
            });
            return obj;
        });

        console.log("Processed Data as Objects:", objectsArray);
        setExtractedData(objectsArray);

        // Here you can dispatch the data to Redux or do whatever you need
        // dispatch(uploadLeads(objectsArray));
    };

    const toTitleCase = (str) => {
        return str
            ?.toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    // const addlead = useCallback(
    //     async (leadsdata) => {
    //         console.log("gsgdhfdh", leadsdata);
    //         console.log("gsgdhfdh leads", leads);

    //         const processedData = leadsdata.map(lead => {
    //             const newLead = { ...lead };
    //             const quotedValue = newLead['QuotedValue ₹'] || '';

    //             // Remove the property with ₹ symbol
    //             delete newLead['QuotedValue ₹'];

    //             // Add new property without ₹
    //             newLead.QuotedValue = quotedValue.replace('₹', '').trim();

    //             return newLead;
    //         });

    //         console.log("Processed data:", processedData);
    //         const duplicateProjects = leadsdata.filter(leadData => {
    //             return leads.some(existingLead =>
    //                 existingLead.ProjectName?.toLowerCase() === leadData.ProjectName?.toLowerCase()
    //             );
    //         });

    //         if (duplicateProjects.length > 0) {
    //             const duplicateNames = duplicateProjects.map(lead => lead.ProjectName || 'Unnamed Project');
    //             console.error("Duplicate project names found:", duplicateNames);
    //             enqueueSnackbar(`Some leads have duplicate project names that already exist in the system: ${duplicateNames.join(', ')}`, {
    //                 variant: "error",
    //             });
    //             return; // Stop execution
    //         }
    //         const invalidMobileLeads = leadsdata.filter(item => {
    //             const mobileNumber = item.MobileNumber || "";
    //             // Remove any non-digit characters (spaces, dashes, etc.)
    //             const digitsOnly = mobileNumber.toString().replace(/\D/g, '');
    //             return digitsOnly.length > 10;
    //         });

    //         // If there are invalid mobile numbers, show error and return
    //         if (invalidMobileLeads.length > 0) {
    //             console.error("Invalid mobile numbers found:", invalidMobileLeads);
    //             enqueueSnackbar(`Some leads have mobile numbers with more than 10 digits. Please check: ${invalidMobileLeads.map(lead => lead.ClientName).join(', ')}`, {
    //                 variant: "error",
    //             });
    //             return; // Stop execution
    //         }
    //         const email = localStorage.getItem("email");

    //         const mappedLeads = processedData.map(item => ({
    //             ClientName: item.ClientName || "",
    //             ClientEmail: item.EmailID || "",
    //             ProjectName: item.ProjectName || "",
    //             LeadDate: item.LeadDate || "",
    //             ClientPhone: item.MobileNumber || "",
    //             QuotedValue: item.QuotedValue || "",
    //             ClientContactName: item.ContactPerson || "",
    //             Status: toTitleCase(item.Status) || "",
    //             Source: toTitleCase(item.Source) || "",
    //             TypeService: item.TypeService || [],
    //             AssignedGroup: item.Group
    //                 ? item.Group.charAt(0).toUpperCase() + item.Group.slice(1)
    //                 : "",

    //             LeadType: item.LeadType || "",
    //             FollowupDate: item.NextFollowupDate || "",
    //             Probability: item.Probability ? toTitleCase(item.Probability) + item.Group.slice(1)
    //                 : "",
    //             // Probability: item.Probability ? item.Probability.charAt(0).toUpperCase() + item.Group.slice(1)
    //             //     : "",
    //             Reference: item.Reference || "",
    //             comments: item.Comments || "",
    //             AssignedPeople: item.AssignedPeople || [],
    //             LeadOwner: item.LeadOwner || "",
    //             LeadOwnerEmail: email || "",
    //             SalesPersonStatus: "project requested",
    //         }));

    //         console.log("gsgdhfdmappedLeads", mappedLeads);


    //         const payload = { leads: mappedLeads }; // parsed excel data
    //         try {
    //             await dispatch(importExcelData(payload));


    //         } catch (error) {

    //             console.error("Error uploading file:", error);
    //         } finally {
    //             if (leadsdata.length > 0) {
    //                 enqueueSnackbar("Leads added successfully", {
    //                     variant: "success",
    //                 });
    //                 navigate(`/dashboard/leadreport`);

    //             }
    //             setExcelData(null)
    //         }
    //     },
    //     [dispatch, enqueueSnackbar, leads, navigate]
    // );
    const addlead = useCallback(
        async (leadsdata) => {
            console.log("gsgdhfdh", leadsdata);
            console.log("gsgdhfdh leads", leads);

            const processedData = leadsdata.map(lead => {
                const newLead = { ...lead };

                // Look for any key that might contain QuotedValue
                const quotedValueKey = Object.keys(newLead).find(key =>
                    key.toLowerCase().includes('quotedvalue')
                );

                if (quotedValueKey) {
                    const quotedValue = newLead[quotedValueKey] || '';
                    // Remove both rupee (₹) and dollar ($) symbols
                    const cleanedValue = quotedValue.toString()
                        .replace(/[₹$,\s]/g, '') // Remove ₹, $, commas, and spaces
                        .trim();

                    // Store the cleaned value
                    newLead.QuotedValue = cleanedValue;

                    // Remove the original property
                    delete newLead[quotedValueKey];
                } else {
                    newLead.QuotedValue = '';
                }

                return newLead;
            });

            console.log("Processed data:", processedData);

            // REFACTORED: Removed duplicate ProjectName check - now allows duplicates if ClientName or AssignedGroup differ
            // UNDO: Uncomment the duplicate check below if reverting
            // Continue with the rest of your code...
            // const duplicateProjects = leadsdata.filter(leadData => {
            //     return leads.some(existingLead =>
            //         existingLead.ProjectName?.toLowerCase() === leadData.ProjectName?.toLowerCase()
            //     );
            // });

            // if (duplicateProjects.length > 0) {
            //     const duplicateNames = duplicateProjects.map(lead => lead.ProjectName || 'Unnamed Project');
            //     console.error("Duplicate project names found:", duplicateNames);
            //     enqueueSnackbar(`Some leads have duplicate project names that already exist in the system: ${duplicateNames.join(', ')}`, {
            //         variant: "error",
            //     });
            //     return; // Stop execution
            // }

            const invalidMobileLeads = leadsdata.filter(item => {
                const mobileNumber = item.MobileNumber || "";
                const digitsOnly = mobileNumber.toString().replace(/\D/g, '');
                return digitsOnly.length > 10;
            });

            if (invalidMobileLeads.length > 0) {
                console.error("Invalid mobile numbers found:", invalidMobileLeads);
                enqueueSnackbar(`Some leads have mobile numbers with more than 10 digits. Please check: ${invalidMobileLeads.map(lead => lead.ClientName).join(', ')}`, {
                    variant: "error",
                });
                return; // Stop execution
            }

            const email = localStorage.getItem("email");

            const mappedLeads = processedData.map(item => ({
                ClientName: item.ClientName || "",
                ClientEmail: item.EmailID || "",
                ProjectName: item.ProjectName || "",
                LeadDate: item.LeadDate || "",
                ClientPhone: item.MobileNumber || "",
                QuotedValue: item.QuotedValue || "", // This will now have the cleaned value
                ClientContactName: item.ContactPerson || "",
                Status: toTitleCase(item.Status) || "",
                Source: toTitleCase(item.Source) || "",
                TypeService: item.TypeService || [],
                AssignedGroup: item.Group
                    ? item.Group.charAt(0).toUpperCase() + item.Group.slice(1)
                    : "",
                LeadType: item.LeadType || "",
                FollowupDate: item.NextFollowupDate || "",
                Probability: item.Probability ? toTitleCase(item.Probability) : "",
                Reference: item.Reference || "",
                comments: item.Comments || "",
                AssignedPeople: item.AssignedPeople || [],
                LeadOwner: item.LeadOwner || "",
                LeadOwnerEmail: email || "",
                SalesPersonStatus: "project requested",
                ...(isWonLeadStatusValue(toTitleCase(item.Status))
                    ? {
                        isDirectWon: true,
                        comments: withDirectWonCommentMarker(item.Comments || ""),
                    }
                    : {}),
            }));

            console.log("gsgdhfdmappedLeads", mappedLeads);

            const payload = { leads: mappedLeads };
            try {
                await dispatch(importExcelData(payload));
            } catch (error) {
                console.error("Error uploading file:", error);
            } finally {
                if (leadsdata.length > 0) {
                    enqueueSnackbar("Leads added successfully", {
                        variant: "success",
                    });
                    navigate(`/dashboard/leadreport`);
                }
                setExcelData(null)
            }
        },
        [dispatch, enqueueSnackbar, leads, navigate]
    );

    useEffect(() => {
        if (!Array.isArray(extractedData) || extractedData.length === 0) return;
        const filteredData = extractedData.filter(item => {
            return Object.values(item).some(value => value !== "");
        });
        if (filteredData.length === 0) return;
        console.log("Transformed data:filteredData", filteredData);


        // Transform the Status field for each item in filteredData
        const transformedfilterData = filteredData.map(item => ({
            ...item,
            Status: item.Status
                .split(' ')  // Split by space
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')   // Join back with space
        }));

        console.log("Transformeddata: ", transformedfilterData);

        const transformedDatainArray = transformedfilterData.map(item => {
            const {
                Probability,
                NextFollowupDate,
                Reference,
                TypeOfService,
                ...rest
            } = item;

            const typeServiceArray = TypeOfService
                ? TypeOfService.split(",")
                    .map(v => v.trim())
                    .filter(v => v !== "")
                    .map(v => v.charAt(0).toUpperCase() + v.slice(1))  // 👈 capitalize first letter
                : [];

            return {
                ...rest,
                Probability,
                NextFollowupDate,
                Reference,
                TypeService: typeServiceArray   // 👈 backend-ready
            };
        });

        // Transform the filtered data based on your conditions
        const transformedData = transformedDatainArray.map(item => {
            const { Probability, NextFollowupDate, Reference, ...rest } = item;

            let transformedItem = { ...rest };

            // Condition 1: If Status is pending, include Probability
            if (item.Status === "pending" || item.Status === "Pending") {
                transformedItem.Probability = Probability;
                transformedItem.NextFollowupDate = NextFollowupDate
            }
            // Condition 2: If Status is Won or lost, exclude Probability and NextFollowupDate
            else if (item.Status === "Won" || item.Status === "lost" || item.Status === "won" || item.Status === "Lost") {

                // Don't include Probability and NextFollowupDate
                // These are already excluded from the rest object
            }
            // Condition 3: If Status is "won recurring", exclude Probability
            else if (item.Status === "won recurring" || item.Status === "Won Recurring") {
                transformedItem.NextFollowupDate = NextFollowupDate

                // Don't include Probability
                // NextFollowupDate is still included from the rest object
            }

            // Condition 4: If Source is "reference", include Reference
            if (item.Source === "reference" || item.Source === "Reference") {
                transformedItem.Reference = Reference;
            }

            return transformedItem;
        });

        // Now use transformedData for further processing
        console.log("Transformed data:", transformedData);
        if (!Array.isArray(transformedData) || transformedData.length === 0) return;
        addlead(transformedData)
    }, [extractedData, addlead]);

    return (
        <div>
            <div className="w-full mb-2">
                <div className="flex items-center gap-3">
                    {leftActions}
                    {canShowDownloadTemplate && (
                        <button
                            onClick={downloadExcel}
                            disabled={isDownloadTemplateViewOnly}
                            className={`text-sm px-4 py-1 rounded ${isDownloadTemplateViewOnly
                                ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                : "cursor-pointer bg-[#e32278] hover:bg-[#e12298] text-white"
                                }`}
                        >
                            Download Template
                        </button>
                    )}
                    {canShowImportLeads && (
                        <div className="gap-2">
                            <input
                                type="file"
                                accept=".xls,.xlsx"
                                id="excel-upload"
                                onChange={handleFileChange}
                                disabled={isImportLeadsViewOnly}
                                className="hidden"
                            />
                            <label
                                onClick={(e) => {
                                    if (isImportLeadsViewOnly) {
                                        e.preventDefault();
                                    }
                                }}
                                htmlFor={isImportLeadsViewOnly ? undefined : "excel-upload"}
                                className={`text-sm px-4 py-1 rounded whitespace-nowrap ${isImportLeadsViewOnly
                                    ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                    : "cursor-pointer bg-black text-white hover:bg-gray-800"
                                    }`}
                            >
                                Import Leads
                            </label>
                        </div>
                    )}
                </div>
                {canShowImportLeads && (
                    <div className='flex justify-end'>
                        <p className="text-[11px] text-black truncate overflow-hidden">
                            <span>
                                {excelData ? excelData.name : "No file selected"}
                            </span>
                            <span className="ml-1 text-red-700">
                                (Only .xls or .xlsx files allowed)
                            </span>
                        </p>
                    </div>
                )}


            </div>
        </div>
    )
}

export default Multipleleadexport;